import React, { Component } from "react";
import { request } from "../../util/APIUtils";
import { ACCESS_TOKEN, API_BASE_URL } from "../../constants";
import "./SurveyCreatePage.css";
import Alert from "react-s-alert";
import {showAxiosError} from "../../util/Helpers";
import LoadingIndicator from "../../common/LoadingIndicator";


function processQuestions(apiQuestions) {
  return apiQuestions.map((q) => ({
    id: q.id,
    type: q.questionType,
    text: q.text,
    choices: q.choices
      ? q.choices.map((c) => ({ id: c.id, choiceText: c.choiceText }))
      : [{}, {}, {}, {}],
  }));
}

class SurveyCreatePage extends Component {
  constructor(props) {
    super(props);
    const defaultQuestion = { type: "", text: "", choices: ["", "", "", ""] };

    this.state = {
      title: "",
      startDate: new Date(),
      endDate: new Date(),
      imagePath: "",
      loading: false,
      isLoading: false,
      error: {},
      questions: [
        {
          id: null,
          type: "",
          text: "",
          choices: [
            { id: null, choiceText: "" },
            { id: null, choiceText: "" },
            { id: null, choiceText: "" },
            { id: null, choiceText: "" },
          ],
        },
      ],
    };

    if (props.survey) {
      this.state = {
        title: props.survey.title,
        startDate: new Date(props.survey.startDate),
        endDate: new Date(props.survey.endDate),
        imagePath: props.survey.imagePath || "",
        questions:
          props.survey.questions.length > 0
            ? processQuestions(props.survey.questions)
            : [defaultQuestion],
      };
    }

    this.handleQuestionTypeChange = this.handleQuestionTypeChange.bind(this);
    this.handleQuestionTextChange = this.handleQuestionTextChange.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this.removeLastQuestion = this.removeLastQuestion.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.cancelProcess = this.cancelProcess.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.validateMessage = this.validateMessage.bind(this);

  }

  handleQuestionTypeChange(e, index) {
    const newQuestions = [...this.state.questions];
    newQuestions[index].type = e.target.value;
    this.setState({ questions: newQuestions });
  }

  handleQuestionTextChange(e, index) {
    const newQuestions = [...this.state.questions];
    newQuestions[index].text = e.target.value;
    this.setState({ questions: newQuestions });
  }

  addQuestion() {
    this.setState((prevState) => ({
      questions: [
        ...prevState.questions,
        { type: "", text: "", choices: ["", "", "", ""] },
      ],
    }));
  }

  removeLastQuestion() {
    if (this.state.questions.length > 1) {
      const newQuestions = [...this.state.questions];
      newQuestions.pop();
      this.setState({ questions: newQuestions });
    }
  }

  validateMessage(id) {
    let error = this.state.error;
    return (error[id] === undefined ? '' : (error[id].message));
}

cancelProcess() {
  this.props.cancelProcess();
}

handleLogout() {
  this.props.handleLogout();
}

  handleSubmit(e) {
    e.preventDefault();


    const isValid = this.state.questions.every(
      (q) =>
        q.type !== "CHOICE" ||
        q.choices.every((choice) => choice.choiceText.trim() !== "")
    );

    if (!isValid) {
      alert("Lütfen tüm şıkları doldurun.");
      return;
    }
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (!token) {
      console.error("Token bulunamadı. Lütfen önce giriş yapın.");
      return;
    }

    const surveyData = {
      title: this.state.title,
      startDate: this.state.startDate.toISOString(),
      endDate: this.state.endDate.toISOString(),
      imagePath: this.state.imagePath,
      questions: this.state.questions.map((q) => ({
        id: q.id,
        text: q.text,
        questionType: q.type,
        choices:
          q.type === "CHOICE"
            ? q.choices.map((c) => ({
                id: c.id,
                choiceText: c.choiceText,
              }))
            : [],
      })),
    };

    let apiUrl;
    let method;
    let self =this;
    let message;
    
    self.setState({isLoading: true});
    if (this.props.survey && this.props.survey.id) {
      message = 'Anket Bilgileri Başarıyla Güncellendi.'
      apiUrl = API_BASE_URL + "/anket/" + this.props.survey.id;
      method = "PUT";
    } else {
      message = 'Anket Bilgileri Başarıyla Kaydedildi.'
      apiUrl = API_BASE_URL + "/anket/add";
      method = "POST";
    }
    const params = {
      url: apiUrl,
      method: method,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: surveyData,
    };
   request(params)
      .then((response) => {
        Alert.success(
          message, {
              position: 'top-right',
              effect: 'stackslide',
              timeout: 5000
          });
      //   if (response.status === 201) {
      //     alert("Anket başarıyla oluşturuldu!");
      //     this.props.history.push("/anketlerim");
      //   } else if (response.status === 200) {
      //     alert("Anket başarıyla güncellendi!");
      //     this.props.history.push("/homePage");
      //   } else {
      //     console.error("Anket oluşturulamadı. Lütfen tekrar deneyin.");
      //   }
      // })
      // .catch((error) => {
      //   console.error("Anket oluşturulurken bir hata oluştu:", error);
      // });
      self.setState({isLoading: false});
            this.cancelProcess();
            self.props.handleSearch(self.props.searchQuery, true);
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });



  }
  cancelProcess() {
    this.props.cancelProcess();
  }
  render() {
    const isUpdateMode = Boolean(this.props.survey);
    const formTitle = isUpdateMode ? "Anketi Güncelle" : "Anket Oluştur";
    const submitButtonText = isUpdateMode
      ? "Anketi Güncelle"
      : "Anketi Oluştur";
    return (
      <div className="form-container">
           {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
        <h2>{formTitle}</h2>
        <div className="button-group">
          <button type="button" className="btnEkle" onClick={this.addQuestion}>
            Soru Ekle
          </button>
          <button
            type="button"
            className="btnSil"
            onClick={this.removeLastQuestion}
          >
            Son Soruyu Sil
          </button>
        </div>
        <form className="survey-form">
          <div className="form-group">
            <label>Anket Başlığı:</label>
            <input
              type="text"
              value={this.state.title}
              onChange={(e) => this.setState({ title: e.target.value })}
            />
          </div>
          <div className="date-group">
            <div className="form-group">
              <label>Başlangıç Tarihi:</label>
              <input
                type="date"
                value={this.state.startDate.toISOString().split("T")[0]}
                onChange={(e) =>
                  this.setState({ startDate: new Date(e.target.value) })
                }
              />
            </div>
            <div className="form-group">
              <label>Bitiş Tarihi:</label>
              <input
                type="date"
                value={this.state.endDate.toISOString().split("T")[0]}
                onChange={(e) =>
                  this.setState({ endDate: new Date(e.target.value) })
                }
              />
            </div>
          </div>
          {this.state.questions.map((q, index) => (
            <div key={index} className="question-section">
              <h3>Soru {index + 1}</h3>
              <div className="form-group">
                <label>Soru Tipi:</label>
                <select
                  value={q.type}
                  onChange={(e) => this.handleQuestionTypeChange(e, index)}
                >
                  <option value="">-- Seçin --</option>
                  <option value="CHOICE">Şıklı</option>
                  <option value="TEXT">Şıksız</option>
                </select>
              </div>
              <div className="form-group">
                <label>Soru:</label>
                <input
                  type="text"
                  value={q.text}
                  onChange={(e) => this.handleQuestionTextChange(e, index)}
                />
              </div>
              {q.type === "CHOICE" && (
                <div>
                  {q.choices.map((c, choiceIndex) => (
                    <div key={choiceIndex} className="form-group">
             <label>{`Şık ${choiceIndex + 1}:`}</label> 
                      <input
                        type="text"
                        value={c.choiceText}
                        onChange={(e) => {
                          const newQuestions = [...this.state.questions];
                          newQuestions[index].choices[choiceIndex].choiceText =
                            e.target.value;
                          this.setState({ questions: newQuestions });
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          <div className="submit-share-buttons">
            <button
              data-toggle="tooltip"
              data-placement="bottom"
              style={{
                background: 'linear-gradient(#2b93cd, #0a66b7)',
                float: "right",
                padding: "10px 54px 10px 23px",
                fontSize:"10px"
              }}
              disabled={this.state.isLoading}
              className="TekBtn add-new-member "
              rel="tooltip"
              type="submit"
              onClick={(e) => this.handleSubmit(e)}
            >
              {submitButtonText}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default SurveyCreatePage;


// WEBPACK FOOTER //
// ./src/page/surveypage/SurveyCreatePage.js